import React from "react";
import backgroundImage from "../../images/background-1.png";
import { FaUser, FaUserShield } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import { useAtom } from "jotai";
import { gbState, globalUserStatus } from "../../components/shared/GlobalState";

const SecondaryRole = () => {
  const navigate = useNavigate();
  const [userStatus, setUserStatus] = useAtom(gbState);

  const handleMemberRole = () => {
    navigate("/member/dashboard", { replace: true });
  };

  const handleAdminRole = () => {
    console.log(userStatus);
    setUserStatus({
      ...userStatus,
      user: {
        ...userStatus.user,
        role: "CHURCH_ADMIN",
      },
    });
    navigate("/v1/dashboard-ca", { replace: true });
  };

  return (
    <div style={styles.background}>
      <div style={styles.loginCard}>
        <h1 style={styles.title}>Select Your Role</h1>
        <div style={styles.roleContainer}>
          <button style={styles.roleButton} onClick={handleMemberRole}>
            <FaUser style={styles.icon} />
            <span style={styles.roleText}>Member</span>
          </button>
          <button style={styles.roleButton} onClick={handleAdminRole}>
            <FaUserShield style={styles.icon} />
            <span style={styles.roleText}>Admin</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecondaryRole;

const styles = {
  background: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  loginCard: {
    backgroundColor: "rgba(0, 31, 63, 0.9)",
    color: "#ffffff",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 15px 30px rgba(0, 0, 0, 0.5)",
    maxWidth: "520px",
    width: "100%",
    margin: "20px",
  },
  logo: {
    display: "block",
    margin: "0 auto 30px",
    maxWidth: "180px",
    height: "auto",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    color: "#87ceeb",
    fontWeight: "600",
    fontSize: "14px",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    backgroundColor: "#003366",
    color: "#ffffff",
    border: "1px solid #4682b4",
    borderRadius: "4px",
    fontSize: "16px",
    transition: "all 0.3s ease",
    "&:focus": {
      borderColor: "#87ceeb",
      boxShadow: "0 0 0 2px rgba(135, 206, 235, 0.3)",
      outline: "none",
    },
  },
  captchaContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  captcha: {
    width: "100%",
    display: "flex",
    justifyContent: "start",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px",
  },
  forgotPassword: {
    color: "#87ceeb",
    textDecoration: "none",
    fontSize: "14px",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#ffffff",
      textDecoration: "underline",
    },
  },
  loginBtn: {
    padding: "12px 25px",
    backgroundColor: "#4682b4",
    color: "#ffffff",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      backgroundColor: "#5693c5",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.25)",
    },
    "&:active": {
      transform: "translateY(0)",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
    },
  },
  buildVersion: {
    marginTop: "30px",
    fontSize: "10px",
    color: "#87ceeb",
    textAlign: "center",
  },
  captchaRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px",
    textAlign: "center",
  },
  roleContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: "20px",
  },
  roleButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "transparent",
    color: "#ffffff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(86, 147, 197, 0.5)",
    },
  },
  icon: {
    width: "50px",
    height: "50px",
    marginBottom: "10px",
  },
  roleText: {
    fontSize: "16px",
    fontWeight: "600",
  },
};
